<template>
  <div class="row d-flex align-items-stretch">
    <div class="col-12 col-sm-3">
      <div class="card h-100" :class="getLikertColor(data)">
        <div
          class="card-body d-flex justify-content-center text-center text-light"
        >
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h5 class="card-title">Likert</h5>
              <h6 class="card-subtitle">1 a 5</h6>
              <h2 class="mb-0">{{ data.average }}</h2>

              <button
                class="btn btn-light btn-sm mt-2"
                title="Detalhar"
                data-bs-toggle="collapse"
                href="#collapse-likert-details"
              >
                <i class="ph ph-list-magnifying-glass"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-9">
      <div class="card h-100">
        <table class="table table-sm table-hover table-striped">
          <thead>
            <tr>
              <th>Tipo</th>
              <th class="text-center">Quantidade</th>
              <th class="text-center">Porcentagem</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in data.labels" :key="item">
              <td>{{ item }}</td>
              <td class="text-center">{{ data.grouped[index] }}</td>
              <td class="text-center">
                {{ calculatePercentage(data.grouped[index]) }}%
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="col-12 collapse" id="collapse-likert-details">
      <div class="card table-responsive mt-2">
        <table
          class="table table-hover table-striped table-sm fs-sm"
          :id="dataTable.id"
        >
          <thead>
            <tr>
              <th>Cliente</th>
              <th>Solicitante</th>
              <th>Técnico</th>
              <th class="text-center">Ticket</th>
              <th class="text-center">Enviado</th>
              <th class="text-center">Respondido</th>
              <th>Pergunta</th>
              <th class="text-center">Resposta</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in data.data" :key="item.id">
              <td>{{ item.organization }}</td>
              <td>{{ item.requester }}</td>
              <td>{{ item.technicianName }}</td>
              <td class="text-center">{{ item.ticketId }}</td>
              <td class="text-center">
                <span class="d-none">{{ item.sendAt }}</span>
                {{ dateTimeSqlToDateTimeBR(item.sendAt) }}
              </td>
              <td class="text-center">
                <span class="d-none">{{ item.answerAt }}</span>
                {{ dateTimeSqlToDateTimeBR(item.answerAt) }}
              </td>
              <td>{{ item.field1 }}</td>
              <td class="text-center">{{ item.value }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { dateTimeSqlToDateTimeBR } from '@/utils/date'
import '@/utils/basicDataTableExtend'

export default {
  name: 'Likert',
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      dateTimeSqlToDateTimeBR,
      dataTable: {
        id: 'dataTableListLikert',
        order: [[4, 'DESC']],
      },
    }
  },
  methods: {
    createDataTable() {
      if (this.table) {
        this.table.destroy()
      }
      this.table = window.$(`#${this.dataTable.id}`).DataTable(this.dataTable)
    },

    getLikertColor(anwser) {
      if (anwser.average >= 4.5) {
        return 'bg-success'
      }
      if (anwser.average >= 3.5) {
        return 'bg-teal'
      }
      if (anwser.average >= 2.5) {
        return 'bg-yellow text-dark'
      }
      if (anwser.average >= 1.5) {
        return 'bg-warning'
      }
      return 'bg-danger'
    },

    calculatePercentage(value) {
      return ((value / this.data.total) * 100).toFixed(2)
    },
  },

  mounted() {
    this.createDataTable()
  },
}
</script>
